var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXTwitter = function SvgXTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.093 6.163 14.673 19.679L5 41.837h3.325l12.924-14.008 10.444 14.008H43L27.505 21.054l13.74-14.89h-3.32L26.023 19.06 16.406 6.163zm4.889 2.452h5.196l22.939 30.764H32.92z"
  })));
};
export default SvgXTwitter;